import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SltSyncErrorService {

  constructor(private http: HttpClient) { }

  /**
   * Get SLT Sync Error Data
   * @param baseUrl Base API URL
   * @param type Type of sync error (e.g., 'GROUP_SYNC_ERROR')
   * @param logId Log ID to fetch error data for
   * @returns Observable with sync error response
   */
  getSltSyncData(baseUrl: string, type: string, logId: any): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_id=32710&input=${type}&log_id=${logId}`;
    
    return this.http.get<any>(url, { withCredentials: true });
  }
}
